/**
 * Component to redirect users to the login page
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

function LoginRedirect({ location }) {
  return (
    <Redirect
      to={{
        pathname: '/login',
        state: { from: location.pathname },
      }}
    />
  );
}

LoginRedirect.propTypes = propTypes;

export default LoginRedirect;
